// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3XvwH","overflowing":"ReadFullNote_overflowing__1AVVK"};